import React from "react";
import { ChecklistOutlined, Delete, EditOutlined } from "@mui/icons-material";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Handle, Position } from "reactflow";
import {
  ICreateWorkflow,
  IGraphNode,
  IWorkFlowCondition,
} from "../../../redux/automation/automation.types";
import { ConditionNodeRightPanel } from "./ConditionNodeRightPanel";
import { formatText } from "../../../helpers";
import styles from '../PlaceholderNode/NodeTypes.module.css';
import clsx from "clsx";
import { useLastNodeDetect } from "../utils/useLastNodeDetect";
import { useAppDispatch } from "../../../redux";
import { upsertContitionNode } from "../../../redux/automation";

export const ConditionNode: React.FC<IGraphNode> = (props) => {
  const { id, data, type, position, } = props;

  const isLastNode = useLastNodeDetect(id);
  const theme = useTheme();


  const node = data.payload as IWorkFlowCondition;


  const [openWorkFlow, setOpenWorkFlow] = React.useState(false);
  const dispatch = useAppDispatch();

  const handleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setOpenWorkFlow(true);
  };

  const handleDelete = () => {
    const finalNode: IWorkFlowCondition = {
      ...data.payload,
      nodes: {
        id: id,
        data: data,
        type: type,
        position: position,
      }
    } as IWorkFlowCondition;

    finalNode.status = "INACTIVE"
    dispatch(upsertContitionNode({ payload: finalNode, onCallback() { } }))
  }

  const getConditions = React.useMemo(() => {
    const conditions = (data.payload as IWorkFlowCondition).conditions;
    if (conditions.length === 1) {
      const conditionList = conditions[0]["and"];
      if (conditionList.length > 0) {
        const condition = conditionList[0];
        return "(" + formatText(condition.view) + "." + formatText(condition.viewColumn) + ") " + condition.operant + " (" + condition.columnOrValue + ")";
      }

    }
    else if (conditions.length > 1) {
      return "Multiple Conditions Added";
    }
    return "";
  }, [data])

  return (
    <>
      <Box
        position={"relative"}
        padding={1}
        border="1px solid #ddd"
        borderRadius={"5px"}
        minWidth={"150px"}
        className={clsx(styles.node)}
        sx={{

          backgroundColor: theme.palette.error.main,

          "&:hover": {

            "& .icon": {
              display: "flex",
            },
          },
        }}

      >
        <Stack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'center'}>
          <ChecklistOutlined sx={{ color: "#fff" }} />
          <Box>
            <Typography
              variant="body1"
              textAlign={"center"}
              fontWeight={800}
              color="#fff"
              fontSize={"0.75rem !important"}
            >
              {data.label}
            </Typography>
            <Typography
              variant="body1"

              textAlign={"center"}
              fontWeight={800}
              color="#000"
              fontSize={"0.55rem !important"}
            >
              {getConditions}
            </Typography>

          </Box>
        </Stack>
        <Stack
          direction={"row"}
          spacing={0.2}
          className="icon"
          position={"absolute"}
          top={-5}
          right={-5}

          display={'none'}
        >
          <Box
            sx={{
              backgroundColor: "#fff",
              boxShadow: theme.shadows[1],

              cursor: "pointer",
              svg: {
                fontSize: "12px",
              },
            }}
            borderRadius={"5px"}
            display={"flex"}
            alignItems={"center"}
            onClick={handleOpen}
            padding={"2px"}
          >
            <EditOutlined fontSize="small" />
          </Box>
          {isLastNode &&
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: theme.shadows[1],

                cursor: "pointer",
                svg: {
                  fontSize: "12px",
                },
              }}
              borderRadius={"5px"}
              padding={"2px"}
              display={"flex"}
              alignItems={"center"}
              onClick={handleDelete}
            >
              <Delete fontSize="small" color="error" />
            </Box>

          }
        </Stack>
        <Handle type="source" position={Position.Bottom} />
        <Handle type="target" position={Position.Top} />
      </Box>
      {openWorkFlow && (
        <ConditionNodeRightPanel
          open={true}
          nodeData={{
            ...data.payload,
            nodes: {
              id: id,
              data: data,
              type: type,
              //@ts-ignore
              position: { x: props.xPos, y: props.yPos },
            },
          } as IWorkFlowCondition}
          onClose={() => setOpenWorkFlow(false)}
        />
      )}
    </>
  );
};
